import { PAGE_SIZE } from '../../../../constants/Config';
import {
    COUNTRY_DELETE,
    COUNTRY_DETAIL,
    COUNTRY_INSERT,
    COUNTRY_LIST,
    COUNTRY_UPDATE,
    COUNTRY_GETALL
} from './action-types';

const initialState = {
    data: [],
    totalRows: 0,
    currentPage: 0,
    pageSize: PAGE_SIZE,
    items: [],
    item: null,
    suggestion: []
};

const country = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case COUNTRY_LIST:
            return list(state, payload);
        case COUNTRY_DETAIL:
            return detail(state, payload);
        case COUNTRY_UPDATE:
            return update(state, payload);
        case COUNTRY_INSERT:
            return insert(state, payload);
        case COUNTRY_DELETE:
            return deletes(state, payload);
        case COUNTRY_GETALL:
            return suggestion(state, payload);
        default:
            return state;
    }
};

function list(state, payload) {
    return { ...state, ...payload };
}
function suggestion(state, payload) {
    state = Object.assign({}, state, {
        suggestion: payload
    });
    return state;
}
function detail(state, payload) {
    return { ...state, item: payload };
}

function deletes(state, payload) {
    const data = state.data.filter(obj => obj.id !== payload);

    return Object.assign({}, state, { data });
}

function update(state, payload) {
    const data = state.data.map(obj => {
        if (obj.id === payload.id) {
            return { ...obj, ...payload };
        }
        return obj;
    });

    return Object.assign({}, state, { data });
}

function insert(state, payload) {
    const data = [...state.data, payload];
    return Object.assign({}, state, { data });
}

export const getCountries = state => state.country.data;
export const getCountryItem = state => state.country.item;

export default country;
